import {
  DefaultPopularMedications,
  PopularMedicationsByCondition,
  PopularMedicationsByNctId,
} from './popularMedications'

/**
 * Popular medications to display in Current Medications question in Apply Flow
 * First checks if there are any medications specific to the trial
 * Then checks if there are any medications specific to the condition
 * Then checks if there are any medications specific to the therapeutic area
 *
 * @param {string | undefined} condition - Condition user selected
 * @param {string} nctId - NCT ID of trial
 * @param {string[]} therapeuticArea - Therapeutic area associated with condition
 * @returns {Array} Names of popular medications
 */
export function getPopularMedications({
  condition,
  nctId,
  therapeuticAreas,
}: {
  condition: string | undefined
  nctId?: string
  therapeuticAreas: string[]
}) {
  const trialSpecificMedications = nctId
    ? PopularMedicationsByNctId.filter((item) => item.nctIds.includes(nctId))
    : []

  if (trialSpecificMedications.length > 0) {
    return trialSpecificMedications.flatMap((item) => item.medications)
  }

  const therapeuticAreaToLookup = therapeuticAreas[0]?.toLowerCase()

  // return condition specific medications regardless of therapeutic area
  const conditionSpecificMedications = condition
    ? PopularMedicationsByCondition.filter((item) =>
        item.conditions.includes(condition.toLowerCase()),
      )
    : []

  if (conditionSpecificMedications.length > 0) {
    return conditionSpecificMedications.flatMap((item) => item.medications)
  }

  // if we can't map to condition then try general therapeutic area
  const therapeuticAreaDefaultMedications = therapeuticAreaToLookup
    ? PopularMedicationsByCondition.filter((item) =>
        item.therapeuticAreas.includes(therapeuticAreaToLookup),
      )
    : []

  if (therapeuticAreaDefaultMedications.length > 0) {
    return therapeuticAreaDefaultMedications.flatMap((item) => item.medications)
  }

  // if we don't know the condition or therapeutic area, return default medications
  return DefaultPopularMedications
}
